import SearchBannersWithIconsBlock from './searchBannersWithIconsBlock'

export default SearchBannersWithIconsBlock
